<template>
  <v-select hide-details outlined :items="items" :value="value" item-text="name" item-value="id" @input="$emit('input', $event)">
    <template #append>
      <mf-icon icon="keyboard_arrow_down" />
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    value: [String, Number],
  },
  data: () => ({
    items: [
      {
        id: '',
        name: 'Todos',
      },
      {
        id: '1',
        name: 'Sim',
      },
      {
        id: '0',
        name: 'Não',
      },
    ],
  }),
}
</script>
